module.exports = __webpack_public_path__ + "img/logo.3cea3329.svg";